import { Button, Tooltip } from "@sede-enterprise/shell-ds-react-framework";
import { InfoCircle } from "@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components";

const InfoLabelWithTooltip = ({ label, tooltipContent }) => (
    <div className='info-label'>
        <p className='data-label'>{label}</p>
        <Tooltip
            className='tooltip'
            placement='bottom'
            overlay={<div className='tooltip-content'>{tooltipContent}</div>}
            trigger={
                <Button size='xsmall' variant='transparent' iconOnly icon={<InfoCircle />} />
            }
        />
    </div>
);


export default InfoLabelWithTooltip;